export default __webpack_public_path__ + "static/media/fig-icons.7cdfaf90.svg";